import React from 'react';
import $ from 'jquery';
import {MWBaseURL} from './../Utilities.js'
import {createApiClient} from "../api/ApiClient";

class TradeTagsTbl extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTrade: props.selectedTrade
		};

		this.tagTbl = null
		this.tradesRefresh = props.tradesRefresh
	}

	componentDidMount() {
		let self = this
		self.tagTbl = $('#tagTbl').DataTable({
			paging: false,
			info: false,
			filter: false,
			data: Array.from(self.state.selectedTrade, i => i["tags"].map(function(x){
				return {tag: x.tag, start: i["start"], end: i["end"], notes: x.notes, id: x.id, tag_id: x.tag_id, deletable: x.deletable}
			})).flat(),
			select: false,
			columns: [
				{title: "Tag", data: "tag", className: "align-middle text-center", width: "25%"},
				{title: "Start", data: "start", className: "align-middle", width: "15%"},
				{title: "End", data: "end", className: "align-middle", width: "15%"},
				{title: "Notes", data: "notes", render: function(data, type, row, meta){
					if(row.deletable){
						return `<button type="button" class="removeTag btn btn-sm text-danger float-right pt-0 pb-0"><svg width="1.2em" height="1.2em" viewBox="0 0 16 16" class="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
							<path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
							<path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
						</svg></button><span style="line-height: 1.8;">`+ data + `</span>`
					}
					return `<span style="line-height: 1.8;">`+ data + `</span>`
				}, className: "align-middle", width: "45%"}
			]
		});

		$(".removeTag").click(function(e){
			let row = self.tagTbl.row($(this).closest("td")[0])


			const apiClient = createApiClient();
			apiClient.post(MWBaseURL()+'tag_trade_delete?', {id: row.data()["id"], tag_id: row.data()["tag_id"]})
			.then(result => {
				row.remove().draw()
				self.tradesRefresh();
			}).catch(error => {
				console.log("Error deleting tag:", error)
			})
		})
	}

	render(){
		return (<div><table id="tagTbl" className="display compact align-middle" width="100%"></table></div>)
	}
}


export default TradeTagsTbl;